import React from 'react';

import Bold from './bold';

const learnings = [
  {
    id: 0,
    text: (
      <span>
        <Bold>The basic principles</Bold> of Design Systems, with their
        complexities de-mythed.
      </span>
    ),
  },
  {
    id: 1,
    text: (
      <span>
        <Bold>Why Design Systems matter</Bold>, from preventing inconsistencies,
        simplifying processes for future projects and harmonising your products.
      </span>
    ),
  },
  {
    id: 2,
    text: (
      <span>
        <Bold>Best practice</Bold> for you and your team to get started in
        building a successful Design System.
      </span>
    ),
  },
  {
    id: 3,
    text: (
      <span>
        <Bold>Exposé on the Design System behind Marvel</Bold>, learn more about
        the workflow that works for us.
      </span>
    ),
  },
];
export default learnings;



// WEBPACK FOOTER //
// ./src/configs/pages/ebook-design-systems/learnings.js